import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { SearchOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  message,
  Popconfirm,
  Row,
  Space,
  Table,
  notification,
  Tooltip,
  Input,
  Form,
  Switch,
} from "antd";
import IMAGES from "../../../const/Image";
import Search from "antd/es/input/Search";
import RoleRequest from "../RoleRequest";
import { components, getRowClassName } from "../../../utils/utils";
//import { usePermission } from "../../../hooks/usePermission";
const initialFilter = { page: 1 };

export const Role = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [labList, setLabList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterForm, setFilterForm] = useState({});
  const [filter, setFilter] = useState(initialFilter);
  const [filteredRoles, setFilteredRoles] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const columns = (navigate) => [
    {
      title: "S No.",
      dataIndex: "sno",
      key: "sno",
      render: (value, item, index) => (filter?.page - 1) * 10 + index + 1,
      width: 70,
    },
    {
      title: "Role Name",
      dataIndex: "roleName",
      key: "roleName",
    },
    {
      title: "Status",
      dataIndex: "isActive",
      width: 120,
      align: "center",
      render: (isActive, item) => (
        <Switch
          checked={isActive}
          checkedChildren="Active"
          unCheckedChildren="Inactive"
          onChange={(checked) => handleStatusChange(checked, item)}
        />
      ),
    },
    {
      title: "Actions",
      dataIndex: "action",
      key: "action",
      width: 90,
      render: (_, record) => (
        <Space size="middle">
          <Tooltip title="Edit Details">
            <span
              className="action-icon-bg"
              onClick={() =>
                navigate(`/user-management/role/edit/${record.roleId}`)
              }
            >
              <img src={IMAGES.EditIcon} />
            </span>
          </Tooltip>
        </Space>
      ),
    },
    // Add other columns as needed
  ];

  const handleStatusChange = (checked, item) => {
    if (!item.id) {
      notification.error({
        message: "Role Id is required to update status.",
      });
      return;
    }
    // showConfirm({
    //   title: `Are you sure you want to ${checked ? "activate" : "deactivate"} this user?`,
    //   okText: "Yes",
    //   cancelText: "No",
    //   onOk() {
    //     setLoading(true);
    //     staffRequest.updateStaff({
    //       status: checked ? 1 : 0,
    //       staffId: item.staffId,
    //     })
    //       .then((res) => {
    //         if (res && res.status === 200) {
    //           notification.success({
    //             message: "User updated successfully",
    //           });
    //           fetchStaffList();
    //         } else {
    //           notification.error({
    //             message: "Failed to update status",
    //           });
    //         }
    //       })
    //       .catch(() => {
    //         notification.error({
    //           message: "Failed to update status",
    //         });
    //       })
    //       .finally(() => {
    //         setLoading(false);
    //       });
    //   },
    // });
  };

  const fetchRoleFilterList = () => {
    setLoading(true);
    RoleRequest.roleFilteredList(filter)
      .then((response) => {
        const rawData = response?.data?.data?.data || [];
        console.log(rawData);
        const totalCount = response?.data?.data?.totalItems || 0;
        console.log(totalCount);
        //setLabList(rawData)
        setFilteredRoles(rawData);
        setTotalRecords(totalCount);
      })
      .catch((error) => {
        message.error("Failed to fetch salon list");
        console.log("error", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchRoleFilterList();
  }, [filter]);

  const handleFilter = (value) => {
    setFilter({ ...filter, ...filterForm, ...initialFilter });
    console.log("filter", filter);
    setIsModalOpen(false);
  };

  const handleChange = (pagination) => {
    setFilter({
      ...filter,
      page: pagination?.current,
    });
  };

  const resetFilters = () => {
    form.resetFields();
    setFilterForm({});
    setFilter(initialFilter);
  };

  const handleSearch = (e) => {
    const searchValue = e.target.value.toLowerCase();
    if (!searchValue) {
      fetchRoleFilterList();
    } else {
      const filteredRole = labList.filter(
        (role) =>
          role.roleTitle && role.roleTitle.toLowerCase().includes(searchValue)
      );
      setLabList(filteredRole);
    }
  };

  return (
    <>
      <div className="">
        <Row gutter={[8, 8]} justify="space-between" align="middle">
          <Col>
            <h1 className="app-heading-med">Roles</h1>
          </Col>
          <Col>
            <div style={{ display: "flex", gap: "1rem" }}>
              {/* <Input
                placeholder="Search..."
                size="large"
                className="FilterSearchBox"
                onChange={(e) => setFilterForm({ ...filterForm, search: e.target.value })}
                value={filterForm?.search}
                style={{ width: "100%" }}

              />
              <Button
                onClick={handleFilter}
                type="primary"
                htmlType="submit"
                className="addcity-btn"
                style={{ height: "39px" }}
              >
                <SearchOutlined />
              </Button> */}
              {/* <Button

                type="primary"
                className="addcity-btn"
                onClick={resetFilters}
                style={{ height: "39px" }}
              >
                Reset
              </Button> */}
              {/* <Button
                onClick={() => navigate("/user-management/role/add")}
                type="primary"
                className="addcity-btn"
                style={{ height: "39px" }}
              >
                <img src={IMAGES.AddIconFilters} alt="Add" />
              </Button> */}
            </div>
          </Col>
        </Row>
      </div>
      <div style={{ marginTop: "20px" }}>
        <Table
          size="middle"
          bordered
          rowClassName={getRowClassName}
          components={components}
          columns={columns(navigate)}
          loading={loading}
          onChange={handleChange}
          dataSource={filteredRoles}
          pagination={{
            total: totalRecords,
            current: filter?.page || 0,
            defaultCurrent: 1,
          }}
        />
      </div>
    </>
  );
};
